export default "__VITE_ASSET__B0FxIrfC__$_?url__"